import {
  getCoinGroup,
  getCoinGroupBalance,
  getCoinGroupCoinList,
} from "@/api/coin";
import { H8Bold, px2rem, SkeletonBox } from "@moim/common";
import * as React from "react";
import { SectionTitle } from "../cryptobadges/styled";
import CoinItemList from "./components/list";
import { Wrapper } from "./styled";

interface IProps {
  id: string;
}
const CoinGroup: React.FC<IProps> = ({ id }) => {
  const [coinGroup, setCoinGroup] = React.useState<
    Moim.Community.Coin.ICoinGroup | undefined
  >(undefined);
  const [coinGroupBalance, setCoinGroupBalance] = React.useState<
    Moim.Community.Coin.ICoinGroupBalance | undefined
  >(undefined);
  const [coins, setCoins] = React.useState<
    Moim.Community.Coin.ICoin[] | undefined | null
  >(undefined);

  React.useEffect(() => {
    if (!id) return;

    getCoinGroup({ id: id }).then(result => {
      setCoinGroup(result);
    });
    getCoinGroupBalance({ id: id }).then(result => {
      setCoinGroupBalance(result);
    });
    getCoinGroupCoinList({ id: id }).then(result => {
      setCoins(result);
    });
  }, [id]);

  return (
    <>
      <SectionTitle>
        {coinGroup?.name ? (
          <H8Bold>{coinGroup?.name}</H8Bold>
        ) : (
          <SkeletonBox width="30%" height={px2rem(21)} />
        )}
      </SectionTitle>
      <Wrapper>
        <CoinItemList coins={coins} coinGroupBalance={coinGroupBalance} />
      </Wrapper>
    </>
  );
};

export default CoinGroup;
